import { render } from "./NodeHeader.vue?vue&type=template&id=5476929d&scoped=true"
import script from "./NodeHeader.vue?vue&type=script&lang=js"
export * from "./NodeHeader.vue?vue&type=script&lang=js"

import "./NodeHeader.vue?vue&type=style&index=0&id=5476929d&scoped=true&lang=css"

import exportComponent from "/Users/victoriengarrigues/Documents/Moonarch-DEV/code/moonarch-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5476929d"]])

export default __exports__